import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from "vuex-persistedstate"

Vue.use(Vuex)

// export default new Vuex.Store({
//     state: {},
//     mutations: {},
//     actions: {},
//     modules: {}
// })


// 引入modules
import info from './info'

import getters from './getters'
import mutations from './mutations'
import actions from './actions'


Vue.use(Vuex)

export default new Vuex.Store({
    plugins: [createPersistedState({
        storage: window.sessionStorage
    })],
    state:{
        info,
    },
    getters,
    mutations,
    actions,

})